import { Button } from '@/shadcn/button';

type Props = {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
};

export const BottomLink = ({ label = '', icon, onClick }: Props) => {
  return (
    <Button
      variant="ghost"
      data-cy={`to-${label.replace(' ', '-').toLowerCase()}`}
      className="font-normal normal-case hover:brightness-95 dark:hover:brightness-125"
      size="sm"
      type="button"
      onClick={onClick}
      aria-label={label}
    >
      {icon && icon} {label}
    </Button>
  );
};
